import React from 'react';
import './CookiePolicy.css';

const CookiePolicy = () => {
  return (
    <div className="policy-page">
      <div className="policy-header">
        <div className="container">
          <h1>Cookie Policy</h1>
          {/* <p>Last updated: April 27, 2026</p> */}
        </div>
      </div>

      <div className="container policy-content my-5">
        <p className="intro">
          This Cookie Policy explains how Thrive Holdings Limited and its subsidiaries ("Thrive Group", "we", "us", or "our") uses cookies and similar tracking technologies when you interact with our website and online services. Thrive Holdings Limited operates through two main subsidiaries: Thrive Insurance Brokers Limited and Thrive Travels & Tours Limited.
        </p>

        <section>
          <h2>Scope of This Policy</h2>
          <p>
            This policy applies to all visitors and users of our website, including insurance clients, travel customers, subscribers, vendors, and partners. It covers cookies used by Thrive Holdings Limited, Thrive Insurance Brokers Limited, and Thrive Travels & Tours Limited. It explains the types of cookies we use, the purposes for which they are used, and how you can manage your cookie preferences.
          </p>
        </section>

        <section>
          <h2>What Are Cookies?</h2>
          <p>
            Cookies are small text files saved to your device by your browser when you visit a website. They help the website remember information about your visit, such as your language preferences, login status, and interactions with the site.
          </p>
        </section>

        <section>
          <h2>How We Use Cookies</h2>
          <p>
            We use cookies to provide, secure, and improve our website experience and services across our insurance and travel divisions. Cookies enable us to:
          </p>
          <ul>
            <li>Authenticate users and keep sessions secure for insurance quotes, travel bookings, and account management.</li>
            <li>Remember your preferences, such as language, display settings, and travel or insurance preferences.</li>
            <li>Customize content and provide relevant insurance products or travel packages.</li>
            <li>Analyze how visitors use the site and identify areas for improvement in our services.</li>
            <li>Measure the effectiveness of marketing campaigns and advertising for both insurance and travel services.</li>
            <li>Process insurance inquiries and provide quotes for our insurance brokerage services.</li>
            <li>Facilitate travel bookings and manage travel itineraries through our travel division.</li>
          </ul>
        </section>

        <section>
          <h2>Types of Cookies We Use</h2>
          <ul>
            <li>
              <strong>Essential Cookies:</strong> Required for the website to function correctly. These include cookies that support navigation, security, user authentication, session management, insurance quote processing, and travel booking functionality.
            </li>
            <li>
              <strong>Performance and Analytics Cookies:</strong> These cookies collect information about how visitors use our site, which insurance products or travel destinations are most popular, and how visitors move through the site. We use this data to optimize performance and improve services for both our insurance brokerage and travel divisions.
            </li>
            <li>
              <strong>Functional Cookies:</strong> These cookies remember your choices and preferences, such as language selection, insurance coverage preferences, travel destinations, and form inputs, to make your next visit easier and more personal.
            </li>
            <li>
              <strong>Marketing and Advertising Cookies:</strong> These are used to deliver tailored advertisements for insurance products and travel packages, limit the number of times you see an ad, and help measure the effectiveness of advertising campaigns across our subsidiaries.
            </li>
          </ul>
        </section>

        <section>
          <h2>How Long Cookies Last</h2>
          <p>
            Some cookies are deleted when you close your browser (session cookies). Others remain on your device for a longer period (persistent cookies) until they expire or you delete them.
          </p>
        </section>

        <section>
          <h2>Third-Party Cookies</h2>
          <p>
            Some cookies used on our site are set by trusted third-party partners, including analytics providers, advertising networks, and social media platforms. These partners may collect information about your browsing activity across different websites.
          </p>
          <p>
            We do not control third-party cookies. Please review the privacy and cookie policies of these third parties to understand how they use your data.
          </p>
        </section>

        <section>
          <h2>Managing Cookies</h2>
          <p>
            You may choose to accept, decline, or delete cookies through your browser settings. You can also block cookies from specific websites. Please note that disabling certain cookies may impact the functionality and performance of our website.
          </p>
          <p>
            To control advertising cookies, you can use tools provided by advertising networks or browser privacy settings to opt out of targeted advertising.
          </p>
        </section>

        <section>
          <h2>Cookies and Personal Data</h2>
          <p>
            Cookies do not always identify you personally. However, some cookies may be linked to information you provide when you sign in, complete contact forms, or engage with our services.
          </p>
        </section>

        <section>
          <h2>Policy Updates</h2>
          <p>
            We may update this Cookie Policy periodically to reflect changes in our practices or legal requirements. When we make material changes, we will post the updated policy on this page and revise the "Last updated" date.
          </p>
        </section>

        <section>
          <h2>Contact Us</h2>
          <p>
            If you have any questions about this Cookie Policy or would like help managing your cookie settings, please visit our <a href="/contact">Contact Us</a> page.
          </p>
        </section>
      </div>
    </div>
  );
};

export default CookiePolicy;
